// extracted by mini-css-extract-plugin
module.exports = {"layout":"DetailsLayout_layout__rZHzp","back":"DetailsLayout_back__D5Y45"};